import * as React from "react";
import { SvgProps } from "../../../utils/interfaces";

const ArrowUpSvg: React.FC<SvgProps> = ({
  width,
  height,
  viewBox = "0 0 24 24",
  color = "#000",
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M11.989 22C12.4711 22 12.823 21.6574 12.823 21.1796V6.78645L12.721 3.76011L12.2174 3.94125L15.7615 7.79845L18.5932 10.5928C18.7327 10.7323 18.9545 10.8156 19.1764 10.8156C19.6355 10.8156 19.9781 10.4585 19.9781 10.0003C19.9781 9.77848 19.899 9.58379 19.723 9.39331L12.6054 2.28317C12.4294 2.09784 12.2202 2 11.989 2C11.7621 2 11.5486 2.09784 11.3727 2.28317L4.25927 9.39331C4.0833 9.58379 4 9.77848 4 10.0003C4 10.4585 4.34257 10.8156 4.8059 10.8156C5.02352 10.8156 5.24536 10.7323 5.38905 10.5928L8.21661 7.79845L11.7513 3.94125L11.2571 3.76011L11.1592 6.78645V21.1796C11.1592 21.6574 11.507 22 11.989 22Z"
        fill={color}
      />
    </svg>
  );
};

export { ArrowUpSvg };
